import { useEffect } from 'react';
import { useAppDispatch } from 'redux/hooks/reduxHooks';
import { setLoading } from 'redux/slices/app/app.slice';

export const useLoading = (isLoading: boolean) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setLoading(isLoading));
  }, [dispatch, isLoading]);
};
